<template>

    <v-card class="slider-card">
        <v-card-text>
            <Loader v-if="loading" :loading="loading"/>

            <v-card-text></v-card-text>
            <v-btn class="close default v-btn--simple"
                   @click="close">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <div v-if="slide">
                <v-layout wrap class="mb-4">
                    <v-flex sm12
                            xs12
                            md5
                            lg3
                    >
                        <v-btn color="success"
                               class="p-0 mb-5"
                               v-bind:disabled="loading"
                               @click="updateItem"
                               text>
                            Сохранить
                        </v-btn>

                        <div class="body-2">Заметка</div>

                        <v-text-field
                                v-model="title"
                        ></v-text-field>

                        <v-checkbox class="mt-4"
                                    v-model="is_active"
                                    label="Виден">
                        </v-checkbox>

                        <br/>

                        <div class="body-2 mb-3 mt-2">Ресурс</div>

                        <multiselect v-model="resource"
                                     tag-placeholder="Выберете или напишите новый"
                                     selectedLabel="Применен"
                                     placeholder="Ресурс"
                                     :showLabels="false"
                                     label="name"
                                     track-by="id"
                                     :options="resourcesSelect"
                                     :taggable="false"
                                     :multiple="false"

                        >
                        </multiselect>


                        <br/>

                        <div class="body-2">Приоритет - чем больше число, тем слайд выше</div>
                        <v-text-field
                                class="mb-5"
                                v-model="position"
                        ></v-text-field>


                        <div class="body-2 mt-4">Ссылка перехода (ссылка)</div>
                        <v-text-field
                                class="mb-5"
                                :clearable="true"
                                v-model="url"
                        ></v-text-field>


                        <br/>

                        <v-btn color="success"
                               v-bind:disabled="loading"
                               @click="updateItem"
                               text>
                            Сохранить
                        </v-btn>
                        <br/>

                    </v-flex>

                    <v-flex sm12
                            xs12
                            md1
                            lg1
                    ></v-flex>

                    <v-flex sm12
                            xs12
                            md4
                            lg2>
                        <div>
                            <div class="body-2 mb-2">
                                Слайдер десктоп версия (прямоугольник) <b class="text-success">[ {{language}} ]</b>
                                <div v-if="image_pcBASE64"
                                     @click="image_pcBASE64=null"
                                     class="right user-link">Отменить
                                </div>
                            </div>

                            <v-checkbox class="mt-1"
                                        v-model="image_pc_remove"
                                        label="Удалить изображение">
                            </v-checkbox>

                            <div class="fileValuePreview mb-4" @click="$refs.fileValuePreview.click()">
                                <input type="file"
                                       ref="fileValuePreview"
                                       @change="uploadValuePreviewBASE64"
                                       accept="image/x-png,image/jpeg,image/jpg"
                                       class="choose-file">

                                <div class="image-shadow"></div>

                                <img v-if="image_pcBASE64" class="image_into BASE64" :src="image_pcBASE64"/>

                                <img v-if="image_pc" class="image_into" :src="image_pc"/>

                                <small class="label-image">Нажмите, чтобы выбрать изображение</small>
                            </div>
                            <br/>

                            <div class="body-2 mb-2">
                                Слайдер мобильная версия (800x800 px) <b class="text-success">[ {{language}} ]</b>
                                <div v-if="image_mobileBASE64"
                                     @click="image_mobileBASE64=null"
                                     class="right user-link">Отменить
                                </div>
                            </div>
                            <v-checkbox class="mt-1"
                                        v-model="image_mobile_remove"
                                        label="Удалить изображение">
                            </v-checkbox>
                            <div class="fileValuePresent" @click="$refs.fileValuePresent.click()">
                                <input type="file"
                                       ref="fileValuePresent"
                                       @change="uploadValuePresentBASE64"
                                       accept="image/x-png,image/jpeg,image/jpg"
                                       class="choose-file">
                                <div class="image-shadow"></div>
                              
                                <img v-if="image_mobileBASE64" class="image_into BASE64" :src="image_mobileBASE64"/>
                               
                                <img v-if="image_mobile" class="image_into" :src="image_mobile"/>

                                <small class="label-image">Нажмите, чтобы выбрать изображение</small>
                            </div>
                            <br/>
                            <v-btn color="success"
                                   v-bind:disabled="loading"
                                   @click="updateItem"
                                   text>
                                Сохранить
                            </v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </div>
        </v-card-text>
    </v-card>

</template>

<script>
    import {mapState} from 'vuex';
    import Loader from "../../helper/Loader";
    import {VueEditor} from 'vue2-editor'


    export default {
        components: {Loader, VueEditor},
        data() {
            return {
                image_mobile: '',
                image_pc: '',
                loading: true,
                page: null,
                url: null,
                resource: null,
                title: null,
                is_active: false,
                image_pc_remove: false,
                image_mobile_remove: false,
                position: 0,
                image_pcBASE64: null,
                image_mobileBASE64: null,
                customToolbar: [],
                customModulesForEditor: []
            }
        },
        props: ['closePage', 'slide'],
        methods: {
            close() {

                this.$dialog
                    .confirm('Закрыть карточку?', {
                        okText: 'Да',
                        cancelText: 'Отмена'
                    })
                    .then(() => {
                        this.closePage(true);
                    })
                    .catch(() => {

                    });
            },

            updateItem() {
                this.loading = true;

                axios.post('admin/sliders/set', {

                    slide_id: this.slide_id,

                    title: this.title,

                    url: (this.url && this.url !== '') ? this.url : null,

                    image_pc_remove: this.image_pc_remove,

                    image_mobile_remove: this.image_mobile_remove,

                    is_active: this.is_active,

                    position: this.position,

                    resource: this.resource,

                    image_pcBASE64: this.image_pcBASE64,

                    image_mobileBASE64: this.image_mobileBASE64

                }).then(response => {

                    if (response.data) {
                        if (response.data.image_mobile) {
                            this.image_mobile = response.data.image_mobile_medium;
                        }
                        if (response.data.image_pc) {
                            this.image_pc = response.data.image_pc_medium;
                        }
                        this.image_pcBASE64 = this.image_mobileBASE64 = null;
                    }


                    if (this.image_pc_remove === true) {
                        this.image_pc = null;
                        this.image_pc_remove = false;
                    }

                    if (this.image_mobile_remove === true) {
                        this.image_mobile = null;
                        this.image_mobile_remove = false;
                    }

                    this.$toast.success({
                        title: 'Изменение параметров',
                        message: 'Вы успешно обновили страницу'
                    });
                }).catch(error => {
                    let data = error.response.data;
                    if (data.errors) {
                        let k = 0;
                        Object.keys(data.errors).forEach((item) => {
                            let err = data.errors[item];
                            k++;
                            for (let i = 0; i < err.length; i++) {
                                setTimeout(() => {
                                    this.$toast.error({
                                        title: 'Ошибка',
                                        message: err[i]
                                    })
                                }, 100 * k);
                            }
                        });
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },

            getPage() {
                setTimeout(() => {
                    if (this.slide) {
                        this.title = this.slide.title;
                        this.resource = this.slide.resource;
                        this.is_active = this.slide.is_active;
                        this.image_pc = this.slide.image_pc_medium;
                        this.image_mobile = this.slide.image_mobile_medium;
                        this.position = this.slide.position;
                        this.url = this.slide.url;
                        this.loading = false;
                    }
                }, 300)
            },

            async uploadValuePreviewBASE64() {
                let new_images = this.$refs.fileValuePreview.files;
                const reader = new FileReader();
                if (new_images &&
                    new_images.length &&
                    new_images[0] &&
                    new_images[0].size < 1048576) {
                    reader.readAsDataURL(new_images[0]);
                    await reader.addEventListener('load', () => {
                        this.image_pcBASE64 = reader.result;
                    });
                } else {

                    this.$toast.error({
                        title: 'Изображение',
                        message: 'Размер изображения не должен быть более 1 мб'
                    });

                    this.image_pcBASE64 = null;
                }
            },

            async uploadValuePresentBASE64() {
                let new_images = this.$refs.fileValuePresent.files;

                const reader = new FileReader();
                if (new_images &&
                    new_images.length &&
                    new_images[0] &&
                    new_images[0].size < 1048576) {
                    reader.readAsDataURL(new_images[0]);
                    await reader.addEventListener('load', () => {
                        this.image_mobileBASE64 = reader.result;
                    });

                } else {
                    this.$toast.error({
                        title: 'Изображение',
                        message: 'Размер изображения не должен быть более 1 мб'
                    });
                    this.image_mobileBASE64 = null;
                }
            },
        },
        computed: {
            ...mapState(['brands', 'resources', 'language']),
            resourcesSelect: {
                get() {
                    return this.resources;
                }
            },

            slide_id: {
                get() {
                    return this.slide.id;
                }
            }
        },
        mounted() {
            this.getPage();
        },
        watch: {}
    }
</script>

<style lang="scss">


    .slider-card {

        .text-white {
            color: #ffffff !important;
            font-weight: 500;
        }

        .fileValuePreview, .fileValuePresent {
            background: #777;
            height: 0;
            width: 100%;
            overflow: hidden;
            position: relative;
            border-radius: 3px;
            cursor: pointer;
        }

        .fileValuePreview {
            padding-top: 50%;

        }

        .fileValuePresent {
            padding-top: 100%;
        }

        .label-image {
            color: #fff;
            position: absolute;
            bottom: 5px;
            left: 10px;
            z-index: 2;
        }

        .image-shadow {
            position: absolute;
            z-index: 1;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            background: rgba(0, 0, 0, 0.4);
            width: 100%;
            height: 100%;
            transition: 0.4s;
        }

        .image-shadow:hover {
            background: transparent;
        }

        .image_into {
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
            z-index: 0;
        }

        .image_into.BASE64 {
            z-index: 1;
        }
    }

</style>
